import { BaseWebComponent } from "./webcomponent-base";

export class SidebarContentWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-content";
    static observedAttributes = [];
    constructor() {
        super();
    }
     render(): void {
        return ; // non c'è niente da renderizzare
    }
}

